module.exports = __webpack_public_path__ + "static/media/ru-RU.702d0100.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/ru-RU.png
// module id = 955
// module chunks = 0